<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-10 14:31:17
 * @LastEditors: smallWhite
 * @LastEditTime: 2024-03-20 11:04:51
 * @FilePath: /huizhou_website/src/components/header_index.vue
-->
<template>
  <div class="header_boxs"
    :class="bgWhite">
    <div class="header"
      :class="isPhone === 'true'?'height_mobile':''">
      <div class="logo"
        v-if="isPhone === 'true'">
        <span
          @click="routerPage(0)">
          <img
            src="../assets/imgaes/logo.png"
            class="logo_img">
        </span>
      </div>
      <div class="nav_boxs">
        <div class="logo"
          v-if="isPhone === 'false'"
          style="margin-right: 30px;">
          <span
            @click="routerPage(0)">
            <img
              src="../assets/imgaes/logo.png"
              class="logo_img">
          </span>
        </div>
        <div class="web_menu"
          v-if="isPhone === 'false'">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#444444"
            active-text-color="#4774b7"
            background-color="#ffffff"
            @select="handleSelect">
            <template
              v-for="(item,i) in menuList">
              <template
                v-if="item.children.length == 0">
                <el-menu-item
                  :index="item.path"
                  @click="gotoPage(item,i)"
                  :key="i">{{ item.name }}</el-menu-item>
              </template>
              <template
                v-else>
                <el-submenu
                  :key="i"
                  class="sub_menu"
                  :index="item.path">
                  <template
                    slot="title">{{ item.name }}</template>
                  <el-menu-item
                    v-for="(child,j) in item.children"
                    :index="child.path"
                    @click="gotoPage(child,i,j)"
                    :key="j">{{ child.name }}</el-menu-item>
                </el-submenu>
              </template>
            </template>

          </el-menu>
        </div>
        <ul class="web_menu"
          v-else>
          <li
            class="web_menu_item"
            :class="{'nav_active':isActive== index}"
            v-for="(item,index) in menuList"
            :key="index">
            <div
              v-if="item.children.length == 0"
              @click="routerPage(index,item)">
              {{item.name}}
            </div>
            <div v-else
              class="second_menu_box"
              :class="{'open_nav':open_nav == index}"
              @mouseleave="mouseleave(index)"
              @mouseover="mouseover(index)">
              {{item.name}}
              <i class="el-icon-arrow-down"
                style="font-size:12px;"></i>
              <ul
                class="second_menu"
                :style="{'top':top + 'px'}">
                <li
                  class="second_li"
                  @click="gotoPage(k,index,j)"
                  v-for="(k,j) in item.children"
                  :key='j'>
                  <span>{{k.name}}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="m-search">
        <div class="suggest"  @click="openDialog">投诉建议</div>
        <el-input placeholder="请输入关键字搜索" style="flex: 1;" v-model="keyworks" prefix-icon="el-icon-search"></el-input>
        <el-button type="primary" style="margin-left: 5px;" @click="gotoSearchPage()">搜索</el-button>
      </div>
      <div
        class="mobile_icon">
        <i class="el-icon-s-fold"
          style="color: #333333;"
          v-if="!openMobile"
          @click="open"></i>
        <i class="el-icon-close"
          style="color: #333333;"
          v-else
          @click="close"></i>
        <div
          class="mobile_menu"
          :class="openMobile">
          <div
            class="menu_item"
            v-for="(item,index) in menuList"
            :key="index">
            <div
              @click="routerPage(index,item)"
              v-if="item.children.length == 0"
              class="menu_title">
              {{item.name}}
            </div>
            <template v-else>
              <div
                @click="openNaves(index)"
                class="menu_title">
                {{item.name}}
                <i
                  class="down el-icon-caret-bottom"></i>
              </div>
              <div
                class="menu_second"
                :class="{'open_navs':open_navs == index}">
                <div
                  class="menu_second_item"
                  @click="gotoPage(k,index,j)"
                  v-for="(k,j) in item.children"
                  :key="j">
                  {{k.name}}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 投诉建议弹窗 -->
    <el-dialog title="投诉建议" :visible.sync="isDialog" style="color: #000000;font-weight: bold;" :modal-append-to-body="false">
      <el-form ref="form" :rules="rules" :model="form">
        <div class="m-title">
          <div class="box"></div>
          <div class="txt">投诉类型(必选)</div>
        </div>
        <el-form-item>
          <el-radio-group v-model="form.type" prop="type">
            <el-radio :label="1">工人工资</el-radio>
            <el-radio :label="2">党风廉政</el-radio>
            <el-radio :label="3">安全生产</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="m-title">
          <div class="box"></div>
          <div class="txt">投诉内容(必填)</div>
        </div>
        <el-form-item prop="content">
          <el-input placeholder="请输入投诉事项" :maxlength="1000" placeholder-style="color:#e4e5e9;" :autosize="{ minRows: 7, maxRows: 100}" type="textarea" v-model="form.content"></el-input>
        </el-form-item>
        <div class="m-title">
          <div class="box"></div>
          <div class="txt">联系人信息(选填)</div>
        </div>
        <el-form-item>
          <el-input placeholder="请输入姓名" :maxlength="30" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入手机号" :maxlength="11" v-model="form.phone" @blur="validatePhone"></el-input>
        </el-form-item>
        <div class="m-title">
          <div class="box"></div>
          <div class="txt">附件</div>
        </div>
        <!-- <div class="m-img">
          +
        </div> -->
        <el-form-item>
          <el-upload
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            name="multipartFile"
            :on-success="handleSuccess"
            :before-upload="beforeUpload" 
            :before-remove="beforeRemove"
            :file-list="fileList"
            :limit="9"
          >
            <!-- <img v-if="url" :src="url" class="avatar"> -->
            <!-- <i class="el-icon-plus avatar-uploader-icon" /> -->
            <!-- <div class="m-img">
              +
            </div> -->
            <div class="m-upload">点击上传</div>
          </el-upload>
        </el-form-item>
        <div>
          <div
            v-for="(item,index) in fileList"
            :key="index"
            class="list_item"
            @click="downLoad(item)">
            <div
              class="list_text">
              <i
                class="el-icon-document" />
              {{ item.name }}
            </div>
            <i class="el-icon-circle-close"
              style="margin-left: 40px;margin-top: 5px;"
              @click.stop="beforeRemove(item)" />
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" class="btn">取 消</el-button>
        <el-button type="primary" @click="submitForm" class="btn">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
// import { baseUrlP } from '@/main.js'; // 根据实际路径调整

// 创建第 axios 实例，设置第二个域名的基础 URL
const service = axios.create({
    baseURL: 'https://phpapi.csjs.hzcci.com',
    timeout: 5000 // 请求超时时间
});
export default {
  data() {
    return {
      activeIndex: '/',
      isActive: 0,
      action:`https://api.csjs.hzcci.com/img/upload`,
      open_nav: 0,
      isPhone: 'false',
      open_navs: 0,
      bgWhite: '',
      openMobile: '',
      scrollTop: 0,
      top: '',
      menuList: [],
      openNav: [],
      keyworks:'',//搜索关键词
      isDialog:false,
      form:{
        type:1,//投诉类型
        content:'',//投诉内容
        name:'',//联系人姓名
        phone:'',//联系人手机号
        file_url:'',//附件
      },
      fileList:[],//附件列表
      uploadList:[],//附件地址列表
      formLabelWidth: '120px',
      rules:{
        type:[{required: true,message: '请选择投诉类型', trigger: 'blur'}],
        content:[{required: true,message: '请输入投诉内容', trigger: 'blur'}],
      }
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        console.log(val)
        this.activeIndex = val.path
        this.$store.commit('setPathIndex', val.path)
      }
    }
  },
  created() {
    this.getMent()
  },
  mounted() {
    if (this.$store.state.index && this.$route.path !== '/') {
      this.activeIndex = this.$store.state.index
    } else {
      // this.activeIndex = '/'
      this.activeIndex = '/'
      this.$store.commit('setPathIndex', '/')
    }
    this.isPhone = window.localStorage.getItem('isPhone')
    if(!this.isPhone){
      this.isPhone = 'false'
    }

    window.addEventListener('scroll', this.getHtmlBodyHeight)
    this.getMent()
  },
  methods: {
    // 提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 手机号验证（如果填写了手机号）
          if (this.form.phone && !/^1[3-9]\d{9}$/.test(this.form.phone)) {
            this.$message.error('请输入正确的手机号码')
            return
          }
          this.form.file_url = this.uploadList.join(',')
          this.submitApi('/app/complaint/saveData', this.form, '添加成功！')
        }
      })
    },
    submitApi(api, data, msg) {
      service.post(api, data).then(res => {
        if (res.status === 200) {
          this.$emit('ok')
          this.$message.success(msg)
          this.closeDialog()
        }
      })
    },
    // 打开弹窗
    openDialog(){
      this.form = this.$options.data().form
      this.fileList = []
      this.uploadList = []
      this.isDialog = true
    },
    // 关闭弹窗
    closeDialog(){
      this.isDialog = false
      this.form = this.$options.data().form
      this.fileList = []
      this.uploadList = []
    },
    // 下载或预览
    downLoad(data) {
      const fileType = data.url.split('.').pop().toLowerCase(); // 获取文件扩展名
      const previewableTypes = ['jpg', 'jpeg', 'png', 'gif', 'pdf']; // 可预览的文件类型
      if (previewableTypes.includes(fileType)) {
        // 如果是可预览的文件类型，直接在新窗口中打开预览
        window.open(data.url, '_blank');
      } else {
        // 对于不可预览的文件类型，执行下载逻辑
        const a = document.createElement('a');
        // 这里是将 url 转成 blob 地址
        fetch(data.url) // 跨域时会报错
          .then(res => res.blob())
          .then(blob => {
            // 将链接地址字符内容转变成 blob 地址
            a.href = URL.createObjectURL(blob);
            a.download = data.name; // 下载文件的名字
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            // 在资源下载完成后 清除 占用的缓存资源
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          })
          .catch(error => {
            console.error('文件下载出错:', error);
          });
      }
    },
    // 下载
    // downLoad(data) {
    //   const a = document.createElement('a')
    //   // 这里是将url转成blob地址，
    //   fetch(data.url) // 跨域时会报错
    //     .then(res => res.blob())
    //     .then(blob => {
    //       // 将链接地址字符内容转变成blob地址
    //       a.href = URL.createObjectURL(blob)
    //       a.download = data.name // 下载文件的名字
    //       a.target = "_blank"
    //       document.body.appendChild(a)
    //       a.click()
    //       // 在资源下载完成后 清除 占用的缓存资源
    //       window.URL.revokeObjectURL(a.href)
    //       document.body.removeChild(a)
    //     })
    // },
    // 移除文件
    beforeRemove(file) {
      // this.$confirm(`确定移除 ${file.name}？`)

      this.fileList = this.fileList.filter(item => {
        return item.name != file.name
      })
    },
    // 上传前的验证
    beforeUpload(file) {
      const allowedTypes = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'bmp', 'webp'];
      const maxSize = 10 * 1024 * 1024; // 10MB
      
      // 获取文件扩展名
      const fileExt = file.name.split('.').pop().toLowerCase();
      
      // 检查文件格式
      if (!allowedTypes.includes(fileExt)) {
        this.$message.error(`上传格式文件错误！只允许格式：jpg,jpeg,png,gif,pdf,bmp,webp`);
        return false;
      }
      
      // 检查文件大小
      if (file.size > maxSize) {
        this.$message.error(`文件大小不能超过10MB！`);
        return false;
      }
      
      return true;
    },
    // 上传成功的钩子
    handleSuccess(res, file) {
       // 二次验证（安全措施）
      const allowedTypes = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'bmp', 'webp'];
      const maxSize = 10 * 1024 * 1024; // 10MB
      
      const fileName = file.name;
      const fileExt = fileName.split('.').pop().toLowerCase();
      const fileSize = file.size;
      
      if (!allowedTypes.includes(fileExt)) {
        this.$message.error(`上传格式文件错误！只允许格式：jpg,jpeg,png,gif,pdf,bmp,webp`);
        return false;
      }
      
      if (fileSize > maxSize) {
        this.$message.error(`文件大小不能超过10MB！`);
        return false;
      }

      this.fileList.push({
        name: file.name,
        url: res.data.previewUrl + '/' + res.data.fileName
      })
      this.uploadList.push(res.data.previewUrl + '/' + res.data.fileName)
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.activeIndex = key
      this.$store.commit('setPathIndex', key)
      this.$router.push(keyPath)
    },
    routerPage(index) {
      this.openMobile = ''
      this.$store.commit('setOpenNav', [index, 0])
      this.isActive = index
      if (index == 0) {
        this.$router.push('/')
        this.$store.commit('setPathIndex', '/')
      }
      this.goTop()
    },
    gotoSearchPage() {
      if(this.keyworks){
        this.$router.push({path:'/search',query:{keyworks:this.keyworks,flag:true}})
        this.goTop()
      }else{
        this.$message.warning('请输入搜索关键词')
      }
    },
    gotoPage(k, index, j) {
      this.openMobile = ''

      this.open_navs = 0
      this.$store.commit('setOpenNav', [index, j])
      this.isActive = index
      this.$store.commit('setPathIndex', k.path)
      this.$router.push(k.path)
      // if (index == 1) {
      //   if (j == 0) this.$router.push('/company_profile')
      //   else if (j == 1) this.$router.push('/development_history')
      //   else if (j == 2) this.$router.push('/management_team')
      //   else if (j == 3) this.$router.push('/leadership_care')
      // } else if (index == 2) {
      //   if (j == 0) this.$router.push('/highway_project')
      //   else if (j == 1) this.$router.push('/government_project')
      //   else if (j == 2) this.$router.push('/bridge_project')
      //   else if (j == 3) this.$router.push('/tunnel_project')
      //   else if (j == 4) this.$router.push('/intellectualization')
      // } else if (index == 3) {
      //   if (j == 0) this.$router.push('/professional_qualification')
      //   else if (j == 1) this.$router.push('/certificate_of_honor')
      //   else if (j == 2) this.$router.push('/technological_innovation')
      // } else if (index == 4) {
      //   if (j == 0) this.$router.push('/project_way_index')
      //   else if (j == 1) this.$router.push('/project_government')
      //   else if (j == 2) this.$router.push('/investment_business')
      //   else if (j == 3) this.$router.push('/engineering_inspection')
      // } else if (index == 5) {
      //   if (j == 0) this.$router.push('/cultural_concept')
      //   else if (j == 1) this.$router.push('/safe_production')
      //   else if (j == 2) this.$router.push('/craftsman_spirit')
      // } else if (index == 6) {
      //   if (j == 0) this.$router.push('/industry_news')
      //   else if (j == 1) this.$router.push('/company_news')
      //   else if (j == 2) this.$router.push('/party_building')
      //   else if (j == 3) this.$router.push('/video_news')
      //   else if (j == 4) this.$router.push('/shape')
      // } else if (index == 7) {
      //   if (j == 0) this.$router.push('/job_recruitment')
      //   else if (j == 1) this.$router.push('/people_develoment')
      //   else if (j == 2) this.$router.push('/team_building')
      // }
      this.goTop()
    },
    getMent() {
      console.log(112)

      axios.post('/home/project', {}).then(res => {
        console.log(12)
        this.menuList = res.data.data.projectList
        console.log(this.menuList, '0000')
        // this.menuList.map((item, index) => {
        //   if (index === 6) {
        //     const obj = {
        //       createTime: '2020-09-24 10:48:13',
        //       id: '6708373832316489729',
        //       isEnable: 0,
        //       name: '闽交品牌',
        //       parentId: '6708371846066081792',
        //       register: '二级',
        //       remark: '闽交品牌',
        //       sort: 4
        //     }
        //     const obj1 = {
        //       createTime: '2020-09-24 10:48:13',
        //       id: '6708373832316489730',
        //       isEnable: 0,
        //       name: '媒体聚焦',
        //       parentId: '6708371846066081792',
        //       register: '二级',
        //       remark: '媒体聚焦',
        //       sort: 4
        //     }
        //     item.children.push(obj, obj1)
        //   }
        // })
        this.$store.commit('setNavList', this.menuList)
      })
    },
    mouseover(e) {
      this.open_nav = e
    },
    mouseleave() {
      this.open_nav = 0
    },
    openNaves(index) {
      this.open_navs = index
    },
    open() {
      this.openMobile = 'open_mobile'
    },
    close() {
      this.openMobile = ''
    },
    getHtmlBodyHeight() {
      //获取滚动时的高度
      const openNav = this.$store.state.openNav
      if (openNav[0] == 0) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (this.scrollTop < 430) {
          this.top = 430 - this.scrollTop - 30
        } else {
          this.bgWhite = ''
        }
      }
    },
    goTop() {
      var timer = null
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop = oTop - 50
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
    // 手机号验证
    validatePhone() {
      if (this.form.phone && !/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      return true
    }
  }
}
</script>

<style>
.second_menu {
  height: 0 !important;
  overflow: hidden;
  opacity: 1 !important;
}
.el-menu-item:hover,
.el-submenu__title:hover {
  background: #4774b7 !important;
  color: #fff !important;
}
.m-search{
  width: 440px;
  display: flex;
  align-items: center;
}
.m-search > .suggest{
  width: 124px;
  height: 60px;
  padding: 0 20px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  color: #333333;
  line-height: 60px;
  font-size: 16px;
  cursor: pointer;
  border-top: 2px solid transparent;
  box-sizing: border-box;
}
.m-search > .suggest:active{
  background: rgb(71, 116, 183);
}


/* 弹窗 */

.m-title{
  width: 100%;
  display: flex;
  align-items: center;
  margin: 12px 0;
}
.m-title > .box{
  width: 4px;
  height: 20px;
  background: #2790f0;
  margin-right: 12px;
}
.m-title > .txt{
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  font-weight: normal;
}
.m-img{
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  background: #f8f8f8;
  border-radius: 16px;
  font-weight: normal;
}
.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-footer > .btn{
  height: 36px;
  padding: 12px 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .sub_menu.el-submenu.is-active .el-submenu__title {
  background: #4774b7 !important;
  color: #fff !important;
} */
/* 上传文件 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  margin: auto;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.list_item {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.list_item:hover {
  cursor: pointer;
  background: #f5f7fa;
  border-bottom: 1px solid #409eff;
  .list_text {
    color: #409eff;
    /* // line-height: 1.2; */
  }
}
.m-upload{
  width: 100px;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2790f0;
  color: #Fff;
  cursor: pointer;
}
</style>
<style scoped>
/deep/.el-dialog__body{
  padding: 10px 20px !important;
}
/deep/.el-dialog__header{
  border-bottom: 2px solid #e5e5e5;
  margin: 0 8px;
}
/deep/.avatar-uploader .el-upload{
  border: none;
}
</style>